import { ChartGantt, List } from "lucide-react";

export const TaskViewSwitch = ({ view, onChange }) => (
  <div className="tasks-view-switch" role="group" aria-label="Vista de tareas">
    {[
      { value: "list", label: "Vista de lista", Icon: List },
      { value: "gantt", label: "Vista Gantt", Icon: ChartGantt },
    ].map(({ value, label, Icon }) => (
      <button
        key={value}
        type="button"
        aria-label={label}
        title={label}
        aria-pressed={view === value}
        onClick={() => onChange(value)}
      >
        <Icon size={18} aria-hidden="true" />
      </button>
    ))}
  </div>
);
